import { FC } from "react";
import {
  IncreaseOfShareCapitalForm,
  PreferentialRightWaivedType,
} from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { TextQuestion, YesNoQuestion } from "../common/commonComponents";
import { VBox } from "../../components-v2/Box";
import { MRadioButtonGroup } from "../../components-v2/RadioButton";

import { useTranslation } from "../../stores/RootStoreContext";
import { RadioFieldModel, StringFieldModel } from "../../common/commonForms";

const ShowPreferentialRight: FC<{ form: IncreaseOfShareCapitalForm }> = observer(({ form }) => {
  const { t } = useTranslation();
  return (
    <>
      <YesNoQuestion
        question={t("decisions.increaseShareCapitalAgainstCash.newShares.preferentialRight")}
        field={form.shareIssue.preferentialRight}
        isLocked={form.isProjectLocked || form.currentNumberOfShares === 0}
      />
      {form.isPreferentialRight && (
        <>
          <YesNoQuestion
            question={t(
              "decisions.increaseShareCapitalAgainstCash.newShares.preferentialRightTransferable",
            )}
            field={form.shareIssue.preferentialRightTransferable}
            isLocked={form.isProjectLocked}
          />
          <YesNoQuestion
            question={t(
              "decisions.increaseShareCapitalAgainstCash.newShares.preferentialRightOversubscribe",
            )}
            field={form.shareIssue.preferentialRightOversubscribe}
            isLocked={form.isProjectLocked}
          />
          <YesNoQuestion
            question={t(
              "decisions.increaseShareCapitalAgainstCash.newShares.preferentialBoardRightsToSellSubscription",
            )}
            field={form.shareIssue.preferentialBoardRightsToSellSubscription}
            isLocked={form.isProjectLocked}
          />
          {
            // Not making any sense having external subscribers since not having allocation functionality.
            // Should add, and support, this once allocation is available.
            /*
          <YesNoQuestion
            question={t(
              "decisions.increaseShareCapitalAgainstCash.newShares.preferentialRightExternalPeople",
            )}
            field={form.shareIssue.externalSubscribers}
            onChange={(e) => form.shareIssue.setExternalSubscribers(e)}
            isLocked={form.isProjectLocked}
          />*/
          }
        </>
      )}
      {form.showPreferentialRightWaivedReason && (
        <PreferentialRightWaivedReason
          model={form.shareIssue.preferentialRightWaivedReasonModel}
          preferentialRightWaivedReasonText={form.shareIssue.preferentialRightWaivedReasonText}
          isProjectLocked={form.isProjectLocked}
        />
      )}
    </>
  );
});

const PreferentialRightWaivedReason = observer(function ({
  model,
  preferentialRightWaivedReasonText,
  isProjectLocked,
}: {
  model: RadioFieldModel<PreferentialRightWaivedType | undefined>;
  preferentialRightWaivedReasonText: StringFieldModel;
  isProjectLocked: boolean;
}) {
  const { t } = useTranslation();
  return (
    <>
      <VBox>
        <div>
          {t(
            "decisions.increaseShareCapitalAgainstCash.newShares.preferentialRightDeviationReason.questionText",
          )}
        </div>
        <MRadioButtonGroup<PreferentialRightWaivedType | undefined>
          name={"preferentialRightWaivedReason"}
          model={model}
          onChange={(_, value) => model.setValue(value)}
          disabled={isProjectLocked}
        />
      </VBox>
      {model.value === PreferentialRightWaivedType.ADDED_EXPLANATION && (
        <TextQuestion
          question={t(
            "decisions.increaseShareCapitalAgainstCash.newShares.preferentialRightDeviationReasonDescription",
          )}
          field={preferentialRightWaivedReasonText}
          isLocked={isProjectLocked}
        />
      )}
    </>
  );
});

export default ShowPreferentialRight;
